import React, {Component} from "react";
import Table from "../components/Table";
import WarehouseItem from "../components/inventory/WarehouseItem";
import {List} from "immutable";
import "../components/Table.scss";
import "./WarehousePage.css";
import ClickHelper from "../lib/ClickHelper";

class WarehousesPage extends Component {

  UNSAFE_componentWillMount() {
    // Load data.
    this.props.loadWarehouses(this.props.meta);
    this.props.setViewContext(this.props.context, "Warehouses");
  }

  componentWillUnmount() {
    this.props.clearSelection(this.props.context);
    this.props.clearViewContext(this.props.context); 
  }

  render() {
    let tableHeader = List([
      "ID",
      "Location",
      "Backup Warehouse",
      "System",
      "Courier"
    ])

    return (
      <Table 
        extraClassName="WarehouseList"
        data={this.props.warehouses} 
        renderer={WarehouseItem} 
        tableHeader={tableHeader}
        selected={this.props.selection}
        onItemClick={this.handleItemClick.bind(this)}
        mode="table"
        itemKey="id" />
    )
  }

  handleItemClick(itemData, e) {
    let {setSelection, toggleSelection, context} = this.props;
    let warehouse_id = itemData.get("id");
    if (ClickHelper.isMetaPressed(e)) {
      toggleSelection(context, warehouse_id);
    } else {
      setSelection(context, warehouse_id);
    }
  }

}

export default WarehousesPage;